import { loadJWT } from '@/helpers/loadJWT';
import { url } from '../../api/api';
import Swal from 'sweetalert2';
import { countryTypes } from '@/redux/types/contryTypes';
import { Country } from '@/types/country/country';

export const getCountries = () => {
  return async (dispatch, getState) => {
    const { token } = loadJWT();

    const countries = getState().country.countries;

    if (countries.length > 0) return;

    dispatch({ type: countryTypes.startLoadingCountries });

    try {
      const resp = await url.get('/paises', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch({
        type: countryTypes.countriesLoad,
        payload: resp.data as Country[],
      });
    } catch (e: any) {
      Swal.fire('Error', e?.response?.data?.error?.message || 'Error al cargar países', 'error');
    } finally {
      dispatch({ type: countryTypes.finishLoadingCountries });
    }
  };
};
